import styled from 'styled-components';

export const LevelMeterTrack = styled.div.attrs({
  className: 'flex h-8 shrink-0 items-center justify-between',
})``;

export const LevelMeterBar = styled.span.attrs({
  className: 'w-0.5 flex-none rounded-sm bg-destructive',
})``;
